import { useRef } from 'react';
import { useReferencedFn } from './useReferencedFn.js';
import throttle from '../node_modules/lodash-es/throttle.js';

const useThrottledCallback = (fn, delay = 200) => {
  const fnRef = useReferencedFn(fn);
  const throttledFn = useRef(throttle((...args) => fnRef.current(...args), delay));
  return throttledFn;
};

export { useThrottledCallback };
//# sourceMappingURL=useThrottledCallback.js.map
